(function () {
    // ===== Toggle hard validation =====
    const VALIDATION_ENABLED = true;
    // ===== AUTO-CENTERING PROGRESS TEXT =====
    function autoCenterProgressText() {
        const progressCircle = document.querySelector('.sidebar__progress-circle');
        const percentageElement = document.querySelector('.progress-circle__percentage');
        const valueElement = document.querySelector('.progress-circle__value');



        // Reset any previous adjustments
        percentageElement.style.transform = '';
        percentageElement.style.marginTop = '';

        // Force a reflow to ensure accurate measurements
        void progressCircle.offsetHeight;

        // Get dimensions
        const circleRect = progressCircle.getBoundingClientRect();
        const valueRect = valueElement.getBoundingClientRect();
        const percentageRect = percentageElement.getBoundingClientRect();

        // Calculate the vertical center of the circle
        const circleCenterY = circleRect.height / 2;

        // Calculate the current center of the percentage element relative to the circle
        const percentageTopRelative = percentageRect.top - circleRect.top;
        const percentageCenterY = percentageTopRelative + (percentageRect.height / 2);

        // Calculate the offset needed for perfect centering
        const offsetY = circleCenterY - percentageCenterY;



        // Only adjust if the offset is significant (more than 1px)
        if (Math.abs(offsetY) > 1) {
            // Use transform for smooth adjustment without affecting layout
            percentageElement.style.transform = `translate(-50%, ${offsetY}px)`;

           
        }
    }



    // Run auto-centering with delays to ensure everything is rendered
    function initProgressCentering() {
        // Initial adjustment after a short delay
        setTimeout(autoCenterProgressText, 100);

        // Adjust after fonts are fully loaded
        if (document.fonts && document.fonts.ready) {
            document.fonts.ready.then(() => {
                setTimeout(autoCenterProgressText, 50);
            });
        }

        // Adjust on window resize (with debouncing)
        let resizeTimeout;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(autoCenterProgressText, 250);
        });

        // Adjust when the progress updates (in case font rendering changes)
        const originalSetProgress = window.setProgress;
        if (originalSetProgress) {
            window.setProgress = function (pct) {
                const result = originalSetProgress(pct);
                // Re-center after progress update
                setTimeout(autoCenterProgressText, 50);
                return result;
            };
        }
    }

    // Enhanced version with multiple adjustment attempts
    function robustProgressCentering() {
        let attempts = 0;
        const maxAttempts = 5;

        function attemptCentering() {
            attempts++;
            autoCenterProgressText();

            // Check if we need another attempt (after DOM/layout updates)
            if (attempts < maxAttempts) {
                setTimeout(attemptCentering, 100 * attempts);
            }
        }

        attemptCentering();
    }


    // Alternative: Manual adjustment function you can call from browser console
    window.adjustProgressPosition = function (manualOffset = 0) {
        const percentageElement = document.querySelector('.progress-circle__percentage');
        if (!percentageElement) return;

        if (manualOffset !== 0) {
            // Manual adjustment
            percentageElement.style.transform = `translate(-50%, calc(-50% + ${manualOffset}px))`;
            
        } else {
            // Auto-detect again
            autoCenterProgressText();
        }
    };

    // Progress ring
    const meter = document.querySelector('.progress-ring__meter');
    const txt = document.querySelector('.progress-circle__percentage');
    const CIRC = 408.4;
    function setProgress(pct) {
        if (!meter) return;
        const clamped = Math.max(0, Math.min(100, pct));
        meter.style.strokeDasharray = CIRC;
        meter.style.strokeDashoffset = CIRC - (CIRC * clamped / 100);
        if (txt) {
            txt.innerHTML =
                '<span class="progress-circle__value">' +
                Math.round(clamped) +
                '</span><span class="progress-circle__unit">%</span>';
        }
    }

    // DOM
    const step1 = document.getElementById('step-1');
    const step2 = document.getElementById('step-2');
    const step3 = document.getElementById('step-3');
    const step4 = document.getElementById('step-4');

    const goToStep2 = document.getElementById('go-to-step-2');
    const backToStep1 = document.getElementById('back-to-step-1');
    const goToStep3 = document.getElementById('go-to-step-3');
    const backToStep2 = document.getElementById('back-to-step-2');
    const goToStep4 = document.getElementById('go-to-step-4');
    const backToStep3 = document.getElementById('back-to-step-3');
    const submitBtn = document.getElementById('submit-form');

    const formEl = document.getElementById('LeasingForm');
    const stepsNav = document.getElementById('form-steps');
    // REPLACE your wireUpDatepicker function with this version

    function isValidDate(dateString) {
        // 1. Regex check for YYYY-MM-DD format
        if (!/^\d{4}-\d{2}-\d{2}$/.test(dateString)) return false;

        // 2. Parse parts to check calendar logic
        const parts = dateString.split('-');
        const year = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10);
        const day = parseInt(parts[2], 10);

        // 3. Basic range check (Year 1900-2100, Month 1-12)
        if (year < 1900 || year > 2100 || month === 0 || month > 12) return false;

        // 4. Strict Day Check using JS Date object
        // (JavaScript automatically rolls over dates, e.g. Feb 30 -> Mar 2)
        // We check if the Input matches the Output to detect invalid days.
        const testDate = new Date(year, month - 1, day);
        return (
            testDate.getFullYear() === year &&
            testDate.getMonth() === month - 1 &&
            testDate.getDate() === day
        );
    }

    function wireUpDatepicker(element) {
        // Ensure jQuery and the datepicker plugin are available
        if (!element || typeof $ === 'undefined' || !$.fn.datepicker) {
            return;
        }

        const $el = $(element);

        // Clean slate
        $el.datepicker('destroy');

        // Attach the double-click listener
        $el.on('dblclick', function () {
            const currentValue = $(this).val();
            let newStartView = 'decades'; // Default: start with years
            let defaultDate = new Date(); // Default to today

            // Logic: Determine where to jump based on what is typed
            const yearMatch = currentValue.match(/^(\d{4})/);
            const monthMatch = currentValue.match(/^\d{4}-(\d{2})/);

            if (monthMatch) {
                // If "2012-05" is typed -> Jump to Days view of May 2012
                newStartView = 'days';
                defaultDate = new Date(parseInt(yearMatch[1]), parseInt(monthMatch[1]) - 1, 1);
            } else if (yearMatch) {
                // If "2012" is typed -> Jump to Months view of 2012
                newStartView = 'months';
                defaultDate = new Date(parseInt(yearMatch[1]), 0, 1); // Jan 1st of that year
            }

            // Prevent jumping to future dates
            if (defaultDate > new Date()) {
                defaultDate = new Date();
            }

            // === THE TRICK ===
            // 1. Temporarily remove the value so the library listens to 'defaultViewDate'
            // instead of trying to parse the incomplete text "2012" and failing.
            $(this).val('');

            // 2. Initialize with our custom settings
            $(this).datepicker('destroy').datepicker({
                format: "yyyy-mm-dd",
                autoclose: true,
                todayHighlight: true,
                startView: newStartView,
                defaultViewDate: defaultDate, // This forces the year/month view
                endDate: "0d",
                forceParse: false // Important: Don't auto-format the text when we put it back
            });

            // 3. Put the user's text back immediately
            $(this).val(currentValue);

            // 4. Show the calendar
            $(this).datepicker('show');

            // Remove default focus behavior so single click doesn't reopen it
            $(this).off('focus');
        });
    }
    function wireUpDateMask(element) {
        if (!element) return;

        element.addEventListener('input', (e) => {
            // 1. Allow only numbers and dashes
            let value = e.target.value.replace(/[^0-9]/g, '');

            // 2. Auto-insert dashes
            if (value.length > 4) {
                value = value.slice(0, 4) + '-' + value.slice(4);
            }
            if (value.length > 7) {
                value = value.slice(0, 7) + '-' + value.slice(7, 9);
            }

            // 3. Hard limit length to 10 chars (YYYY-MM-DD)
            if (value.length > 10) {
                value = value.slice(0, 10);
            }

            e.target.value = value;
        });

        element.addEventListener('blur', (e) => {
            const value = e.target.value;

            if (!value.length) {
                // Empty: clear any existing error for this field
                clearErrorFor(e.target);
                return;
            }

            if (!isValidDate(value)) {
                showError(e.target, 'Invalid Date (YYYY-MM-DD)');
            } else {
                // Value is now valid – remove the tooltip immediately
                clearErrorFor(e.target);
            }
        });
    }

    // ===== NEW: Shareholder Home Status logic =====
    const shareholderHomeStatusRadios = formEl?.querySelectorAll('input[name="shareholders[0][home_status]"]');
    const homeValueGroup = document.getElementById('Shareholders-0-HomeValue')?.closest('.form-group');
    const mortgageBalanceGroup = document.getElementById('Shareholders-0-MortgageBalance')?.closest('.form-group');

    function handleHomeStatusChange() {
        if (!shareholderHomeStatusRadios || !homeValueGroup || !mortgageBalanceGroup) return;

        const isLessee = formEl.querySelector('input[name="shareholders[0][home_status]"][value="Lessee"]')?.checked;

        homeValueGroup.classList.toggle('is-hidden', isLessee);
        mortgageBalanceGroup.classList.toggle('is-hidden', isLessee);

        // If hidden, clear the values so they don't get validated or included in progress
        if (isLessee) {
            const hvInput = homeValueGroup.querySelector('input');
            const mbInput = mortgageBalanceGroup.querySelector('input');
            if (hvInput) hvInput.value = '';
            if (mbInput) mbInput.value = '';
        }
        // Re-calculate progress since fields might have been cleared or become irrelevant
        computeProgress();
    }
    // ===== END NEW SECTION =====

    // ===== NEW: Commercial Bankruptcy → Date of Release toggle (Company + Shareholder #0) =====
    function toggleGroupVisibility(inputEl, show) {
        // Find a suitable container to hide/show
        const group =
            inputEl?.closest('.form-group') ||
            inputEl?.closest('.field-host') ||
            inputEl?.parentElement;
        if (!group) return;
        group.classList.toggle('is-hidden', !show);
        if (!show) {
            // Clear inputs within so they don't validate or count toward progress
            group.querySelectorAll('input, select, textarea').forEach(el => { el.value = ''; });
        }
    }

    // Company-level Date of Release (adjust the ID if yours differs)
    const companyDateReleaseInput = document.getElementById('Company-DateOfRelease');
    const companyBankruptcyRadios = formEl?.querySelectorAll('input[name="commercial_bankruptcy"]');

    function handleCompanyBankruptcyToggle() {
        if (!companyDateReleaseInput || !companyBankruptcyRadios) return;
        const isYes = !!formEl.querySelector('input[name="commercial_bankruptcy"][value="Yes"]:checked');
        toggleGroupVisibility(companyDateReleaseInput, isYes);
        computeProgress();
    }

    // Shareholder #0 Date of Release (adjust the ID if yours differs)
    const shDateReleaseInput = document.getElementById('Shareholders-0-DateOfRelease');
    const shBankruptcyRadios = formEl?.querySelectorAll('input[name="shareholders[0][commercial_bankruptcy]"]');

    function handleShareholderBankruptcyToggle() {
        if (!shDateReleaseInput || !shBankruptcyRadios) return;
        const isYes = !!formEl.querySelector('input[name="shareholders[0][commercial_bankruptcy]"][value="Yes"]:checked');
        toggleGroupVisibility(shDateReleaseInput, isYes);
        computeProgress();
    }
    // ===== END NEW SECTION =====

    // Make sure browser HTML5 validation doesn't short-circuit our JS rules
    formEl?.setAttribute('novalidate', 'novalidate');

    function setActiveStep(n) {
        stepsNav?.querySelectorAll('.step').forEach(li => {
            li.classList.toggle('step--active', li.getAttribute('data-step') === String(n));
        });
    }
    function showStep(n) {
        [step1, step2, step3, step4].forEach((s, i) => {
            if (!s) return;
            if (i === n - 1) s.classList.remove('is-hidden');
            else s.classList.add('is-hidden');
        });
        setActiveStep(n);
    }

    // Sticky offset for scroll positioning
    function measureStickyStack() {
        const candidates = [
            document.getElementById('shopify-section-header'),
            document.querySelector('.shopify-section-header'),
            document.querySelector('.announcement-bar-holder'),
            document.querySelector('header'),
        ];
        let maxBottom = 0;
        for (const el of candidates) {
            if (!el) continue;
            const r = el.getBoundingClientRect();
            if (r.top <= 2) maxBottom = Math.max(maxBottom, r.bottom);
        }
        return Math.ceil(maxBottom + 12);
    }
    function syncScrollPaddingTop() {
        const off = measureStickyStack();
        document.documentElement.style.setProperty('--sticky-offset', off + 'px');
    }
    function setTitleScrollMargin(sectionEl) {
        const title = sectionEl?.querySelector('.form-content__title');
        if (!title) return;
        title.style.scrollMarginTop = measureStickyStack() + 'px';
    }

    // Scroll utils
    function getScrollContainer(el) {
        let node = el?.parentElement || null;
        while (node && node !== document.body) {
            const style = getComputedStyle(node);
            const canScrollY = /(auto|scroll|overlay)/.test(style.overflowY) && node.scrollHeight > node.clientHeight;
            if (canScrollY) return node;
            node = node.parentElement;
        }
        return window;
    }
    function getScrollTop(scroller) {
        return scroller === window
            ? window.pageYOffset || document.documentElement.scrollTop || 0
            : scroller.scrollTop;
    }
    function setScrollTop(scroller, value) {
        if (scroller === window) window.scrollTo(0, value);
        else scroller.scrollTop = value;
    }
    function easeInOutCubic(t) {
        return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
    }
    function animateScrollTo(scroller, to, { duration = 800 } = {}) {
        const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (prefersReduced) { setScrollTop(scroller, to); return Promise.resolve(); }
        const start = getScrollTop(scroller);
        const change = to - start;
        if (Math.abs(change) < 1) return Promise.resolve();
        const px = Math.abs(change);
        duration = Math.min(1100, Math.max(550, (px / 1200) * 900));
        return new Promise(resolve => {
            const startTime = performance.now();
            function step(now) {
                const t = Math.min(1, (now - startTime) / duration);
                const eased = easeInOutCubic(t);
                setScrollTop(scroller, start + change * eased);
                if (t < 1) requestAnimationFrame(step); else resolve();
            }
            requestAnimationFrame(step);
        });
    }

    function scrollTitleIntoView(sectionEl) {
        
        const title = sectionEl?.querySelector('.form-content__title');
        if (!title) return;
        const scroller = getScrollContainer(title);
        const offset = measureStickyStack();
        const titleRect = title.getBoundingClientRect();
        const baseTop = scroller === window
            ? titleRect.top + getScrollTop(window)
            : titleRect.top + scroller.scrollTop - scroller.getBoundingClientRect().top;
        const desiredY = baseTop - offset;
        animateScrollTo(scroller, desiredY).then(() => {
            const containerTop = scroller === window ? 0 : scroller.getBoundingClientRect().top;
            const delta = title.getBoundingClientRect().top - (offset + containerTop);
            if (Math.abs(delta) > 1) setScrollTop(scroller, getScrollTop(scroller) + delta);
        });
    }

    function scrollToFormTopMobile() {
        
        if (!window.matchMedia('(max-width: 600px)').matches) return false;
        const formTopElement = document.querySelector('.leasing-form-outer-wrapper');
        if (!formTopElement) return false;
        const scroller = getScrollContainer(formTopElement);
        const offset = measureStickyStack();
        const rect = formTopElement.getBoundingClientRect();
        const scrollTop = getScrollTop(scroller);
        const extraMobileNudge = 10;
        const baseTop = scroller === window
            ? rect.top + scrollTop
            : rect.top + scrollTop - scroller.getBoundingClientRect().top;
        const targetY = baseTop - offset - extraMobileNudge;
        animateScrollTo(scroller, targetY);
        return true;
    }
    function scrollAfterReveal(sectionEl) {
        requestAnimationFrame(() => {
            if (scrollToFormTopMobile()) return;
            scrollTitleIntoView(sectionEl);
        });
    }

    // ===== Tooltip CSS (no-shift errors) =====
    (function injectTooltipCSS() {
        const css = `
        .field-host{ position:relative; }
        .field-error{
          position:absolute; left:0; top:73%; transform:translateY(6px);
          z-index:10; color:#b42318; background:#fff; border:1px solid #f3b4b1;
          border-radius:4px; padding:2px 6px; font-size:.85rem; line-height:1.2;
          white-space:nowrap; pointer-events:none; box-shadow:0 1px 2px rgba(0,0,0,.06);
        }
        .field-error::after{
          content:""; position:absolute; left:10px; top:-6px;
          border-left:6px solid transparent; border-right:6px solid transparent;
          border-bottom:6px solid #f3b4b1;
        }
        .field-error::before{
          content:""; position:absolute; left:10px; top:-5px;
          border-left:6px solid transparent; border-right:6px solid transparent;
          border-bottom:6px solid #fff;
        }
        /* keep net-worth grid tidy when tooltips show */
        .nw-grid{ align-items:start; }
        .no-spinner::-webkit-outer-spin-button,.no-spinner::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}
        .no-spinner{-moz-appearance:textfield}
  
        /* ===== FINAL, PRECISE DESKTOP ALIGNMENT FIX ===== */
        @media (min-width: 769px) {
          /*
           * This rule explicitly targets ONLY the parent .form-group of the three
           * specific fields that need special alignment on desktop.
          */
          .form-group:has(#Shareholders-0-HowLong) > .field-error,
          .form-group:has(#Shareholders-0-HomeValue) > .field-error,
          .form-group:has(#Shareholders-0-MortgageBalance) > .field-error {
            left: 18%; /* Your chosen value */
          }
        }
        /* ===== END FINAL FIX ===== */
      `;
        const s = document.createElement('style');
        s.type = 'text/css';
        s.appendChild(document.createTextNode(css));
        document.head.appendChild(s);
    })();

    // ===== Error helpers (tooltip host aware) =====
    function clearErrors(scope) {
        (scope || document).querySelectorAll('.field-error').forEach(n => n.remove());
        (scope || document).querySelectorAll('[aria-invalid="true"]').forEach(n => n.setAttribute('aria-invalid', 'false'));
    }
    function clearErrorFor(inputEl) {
        if (!inputEl) return;

        inputEl.setAttribute('aria-invalid', 'false');

        const host =
            inputEl.closest('.field-host') ||
            inputEl.closest('.nw-field') ||
            inputEl.closest('.form-group') ||
            inputEl.closest('.radio-question') ||
            inputEl.closest('.radio-options') ||
            inputEl.parentElement;

        if (!host) return;

        const existing = host.querySelector(':scope > .field-error');
        if (existing) existing.remove();
    }

    function showError(inputEl, msg) {
        if (!inputEl) return;
        inputEl.setAttribute('aria-invalid', 'true');

        // host for absolute positioning (prefer existing)
        const host =
            inputEl.closest('.field-host') ||
            inputEl.closest('.nw-field') ||
            inputEl.closest('.form-group') ||
            inputEl.closest('.radio-question') ||
            inputEl.closest('.radio-options') ||
            inputEl.parentElement;

        if (!host) return;

        const existing = host.querySelector(':scope > .field-error');
        if (existing) { existing.textContent = msg; return; }

        const hint = document.createElement('div');
        hint.className = 'field-error';
        hint.setAttribute('role', 'status');
        hint.setAttribute('aria-live', 'polite');
        hint.textContent = msg;
        host.appendChild(hint);
    }
    function focusAndScrollTo(el) {
        try { el.focus({ preventScroll: true }); } catch { }
        const scroller = getScrollContainer(el);
        const offset = measureStickyStack();
        const rect = el.getBoundingClientRect();
        const baseTop = (scroller === window)
            ? rect.top + getScrollTop(window)
            : rect.top + scroller.scrollTop - scroller.getBoundingClientRect().top;
        animateScrollTo(scroller, baseTop - Math.max(0, offset) - 12);
    }

    // ===== REQUIRED CHECKBOX HELPERS (NEW) =====
    // Accepts a CSS scope (section) and ensures *any* checkbox marked required is checked.
    function requireRequiredCheckboxes(scope) {
        const root = scope || document;
        const boxes = root.querySelectorAll('input[type="checkbox"][required], input[type="checkbox"][data-required], input[type="checkbox"][aria-required="true"]');
        for (const box of boxes) {
            if (!box.checked) {
                showError(box, 'Please check this box to proceed.');
                focusAndScrollTo(box);
                return false;
            }
        }
        return true;
    }
    // Single checkbox by ID or name. Safe if not present in this step.
    function requireCheckbox(root, selectorOrName, msg) {
        const rootEl = root || document;
        const el =
            rootEl.querySelector(selectorOrName) ||
            rootEl.querySelector(`input[name="${selectorOrName}"]`);
        if (!el) return true;
        if (!el.checked) {
            showError(el, msg || 'Please check this box to proceed.');
            focusAndScrollTo(el);
            return false;
        }
        return true;
    }

    // ===== Progress: ONLY required items =====
    const byName = (n) => formEl?.querySelector(`[name="${n}"]`);
    const val = (n) => (byName(n)?.value || '').toString().trim();
    const radio = (n) => !!formEl?.querySelector(`[name="${n}"]:checked`);
    const onlyDigits = (v) => (v || '').replace(/\D/g, '');
    function isEmailOk() {
        const el = document.getElementById('LeasingForm-email');
        return !!el && !!el.value && el.checkValidity();
    }
    const phoneOk = (id) => onlyDigits(document.getElementById(id)?.value || '').length === 10;
    const atLeastOnePhoneOk = (ids) => ids.some(id => phoneOk(id));

    function computeProgress() {
        let required = 0, satisfied = 0;

        // --- Step 1 required items
        const step1Req = [
            () => { required++; const ok = isEmailOk(); if (ok) satisfied++; },                                  // email
            () => { required++; const ok = !!val('legal_name_of_business'); if (ok) satisfied++; },
            () => { required++; const ok = !!val('operating_name'); if (ok) satisfied++; },
            () => { required++; const ok = !!val('activity_area'); if (ok) satisfied++; },
            () => { required++; const ok = !!val('address'); if (ok) satisfied++; },
            () => { required++; const ok = !!val('years_in_business'); if (ok) satisfied++; },
            () => { // at least one phone (business or mobile)
                required++;
                const ok = atLeastOnePhoneOk(['LeasingForm-business-phone', 'LeasingForm-mobile-number']);
                if (ok) satisfied++;
            },
            () => { required++; const ok = radio('commercial_bankruptcy'); if (ok) satisfied++; },
            () => { required++; const ok = radio('legal_actions'); if (ok) satisfied++; },
        ];
        step1Req.forEach(fn => fn());

        // --- Step 2: optional unless started
        if (step2) {
            const wrap = step2.querySelector('.shareholder');
            if (wrap) {
                const started = Array.from(wrap.querySelectorAll('input')).some(i => (i.value || '').trim().length);
                if (started) {
                    const reqFns = [
                        () => { required++; const ok = !!val('shareholders[0][contact_name]'); if (ok) satisfied++; },
                        () => { required++; const ok = !!val('shareholders[0][address]'); if (ok) satisfied++; },
                        () => { // at least one phone
                            required++;
                            const ok = atLeastOnePhoneOk(['Shareholders-0-Phone', 'Shareholders-0-Mobile']);
                            if (ok) satisfied++;
                        },
                        () => { required++; const ok = radio('shareholders[0][home_status]'); if (ok) satisfied++; },
                        () => { required++; const ok = !!val('shareholders[0][how_long]'); if (ok) satisfied++; },
                    ];
                    reqFns.forEach(fn => fn());

                    // ===== NEW LOGIC (PROGRESS BAR) =====
                    // If Home Owner is selected, Home Value and Mortgage Balance are now required for progress.
                    const getRadioVal = (name) => (formEl?.querySelector(`[name="${name}"]:checked`)?.value || '').trim();
                    if (getRadioVal('shareholders[0][home_status]') === 'Home Owner') {
                        required += 2; // Always require them if Home Owner is selected.
                        if (val('shareholders[0][home_value]')) satisfied++;
                        if (val('shareholders[0][mortgage_balance]')) satisfied++;
                    }
                }
            }
        }

        // --- Step 3: progress = completeness of the SINGLE best owner (fixed 4 fields)
        if (step3) {
            const rows = Array.from(step3.querySelectorAll('.ownership-row'));
            // Always require one owner (4 fields)
            const FIELDS_PER_OWNER = 4;
            required += FIELDS_PER_OWNER;

            // Calculate completeness for each row
            let bestComplete = 0;

            rows.forEach((row, idx) => {
                const name = row.querySelector('input[name$="[contact_name]"]');
                const addr = row.querySelector('input[name$="[address]"]');
                const dob = row.querySelector('input[name$="[dob]"]');
                const pct = row.querySelector('input[name$="[percent]"]');

                // Consider "started" if any input has a value
                const started = [name, addr, dob, pct].some(i => (i?.value || '').trim().length);
                if (!started && idx !== 0) return; // ignore empty extra rows for progress

                // Score this row
                let complete = 0;
                if ((name?.value || '').trim()) complete++;
                if ((addr?.value || '').trim()) complete++;
                if ((dob?.value || '').trim()) complete++;

                const n = parseInt((pct?.value || '').trim(), 10);
                if (!isNaN(n) && n >= 25 && n <= 100) complete++;

                // Track the most complete single owner
                if (complete > bestComplete) bestComplete = complete;
            });

            // Add only the best owner's completeness to satisfied
            satisfied += bestComplete;
        }

        // --- Step 4: required groups (Cash/Savings/Investments and Debts)
        if (step4) {
            const savingsReq = [
                'networth[savings][cash_savings][market_value]',
                'networth[savings][cash_savings][liability]',
                'networth[savings][cash_savings][to_whom]',
                'networth[savings][stock_investments][market_value]',
                'networth[savings][stock_investments][liability]',
                'networth[savings][stock_investments][to_whom]',
                'networth[savings][rrsps][market_value]',
                'networth[savings][rrsps][liability]',
                'networth[savings][rrsps][to_whom]',
            ];
            const debtsReq = [
                'networth[debts][credit_card_debt][liability]',
                'networth[debts][credit_card_debt][to_whom]',
                'networth[debts][personal_loans][liability]',
                'networth[debts][personal_loans][to_whom]',
                'networth[debts][other_debts][liability]',
                'networth[debts][other_debts][to_whom]',
            ];
            [...savingsReq, ...debtsReq].forEach(n => {
                required++;
                if (val(n)) satisfied++;
            });
        }

        setProgress(required ? (satisfied / required) * 100 : 0);
    }

    // Init
    document.querySelectorAll('input[type="radio"]').forEach(r => { r.checked = false; });
    (function injectNoSpinnerCSS() {
        const css = `
        .no-spinner::-webkit-outer-spin-button,
        .no-spinner::-webkit-inner-spin-button { -webkit-appearance: none; margin: 0; }
        .no-spinner { -moz-appearance: textfield; }
      `;
        const style = document.createElement('style');
        style.type = 'text/css';
        style.appendChild(document.createTextNode(css));
        document.head.appendChild(style);
    })();
    setProgress(0);
    setActiveStep(1);
    syncScrollPaddingTop();
    setTitleScrollMargin(step1);


    // Wrap fields so tooltips have a positioning host
    function wrapAllFieldsForTooltips() {
        const form = formEl;
        if (!form) return;
        const selector = [
            'input:not([type="hidden"]):not([type="button"]):not([type="submit"])',
            'textarea',
            'select'
        ].join(',');

        form.querySelectorAll(selector).forEach((el) => {
            if (el.closest('.field-host')) return;
            const prefer = el.closest('.nw-field') || el.closest('.form-group');
            if (prefer) { prefer.classList.add('field-host'); return; }
            // radios: mark group containers
            const rq = el.closest('.radio-question') || el.closest('.radio-options');
            if (rq) { rq.classList.add('field-host'); return; }
            // fallback: wrap
            const wrap = document.createElement('div');
            wrap.className = 'field-host';
            el.replaceWith(wrap);
            wrap.appendChild(el);
        });
        // radio groups explicit
        form.querySelectorAll('.radio-question, .radio-options').forEach(g => g.classList.add('field-host'));
    }

    computeProgress();

    formEl?.addEventListener('input', (e) => { clearErrors(e.target.closest('section')); computeProgress(); }, { passive: true });
    formEl?.addEventListener('change', (e) => { clearErrors(e.target.closest('section')); computeProgress(); }, { passive: true });

    // ===== NEW: Attach listeners for toggles =====
    shareholderHomeStatusRadios?.forEach(radio => {
        radio.addEventListener('change', handleHomeStatusChange);
    });
    companyBankruptcyRadios?.forEach(r => {
        r.addEventListener('change', handleCompanyBankruptcyToggle);
    });
    shBankruptcyRadios?.forEach(r => {
        r.addEventListener('change', handleShareholderBankruptcyToggle);
    });

    window.addEventListener('resize', () => {
        syncScrollPaddingTop();
        [step1, step2, step3, step4].forEach(s => {
            if (s && !s.classList.contains('is-hidden')) setTitleScrollMargin(s);
        });
        enhanceNetWorthMobile();
        wrapAllFieldsForTooltips(); // ensure new mobile wrappers become hosts
    }, { passive: true });

    // Email + phone guards
    function ensureEmailValidOrFocus() {
        const email = document.getElementById('LeasingForm-email');
        if (!email) return true;
        if (!email.value || !email.checkValidity()) {
            showError(email, 'Please enter a valid email.');
            focusAndScrollTo(email);
            return false;
        }
        return true;
    }

    function fmtPhone(digits) {
        const d = onlyDigits(digits).slice(0, 10);
        if (d.length <= 3) return d;
        if (d.length <= 6) return `(${d.slice(0, 3)}) ${d.slice(3)}`;
        return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
    }
    function wirePhoneInput(el) {
        if (!el) return;
        el.setAttribute('maxlength', '14');
        el.addEventListener('input', () => {
            const d = onlyDigits(el.value);
            el.value = fmtPhone(d);
            if (d.length === 10) el.setCustomValidity('');
            computeProgress();
        });
        el.addEventListener('blur', () => {
            const d = onlyDigits(el.value);
            if (d.length > 0 && d.length !== 10) {
                el.setCustomValidity('Please enter a 10-digit phone number.');
                el.reportValidity?.();
            } else {
                el.setCustomValidity('');
            }
        });
    }
    [
        'LeasingForm-business-phone',
        'LeasingForm-mobile-number',
        'Shareholders-0-Phone',
        'Shareholders-0-Mobile'
    ].forEach(id => wirePhoneInput(document.getElementById(id)));

    function phonesValidSoft() {
        const ids = ['LeasingForm-business-phone', 'LeasingForm-mobile-number', 'Shareholders-0-Phone', 'Shareholders-0-Mobile'];
        for (const id of ids) {
            const el = document.getElementById(id);
            if (!el) continue;
            const d = onlyDigits(el.value);
            if (d.length > 0 && d.length !== 10) {
                showError(el, 'This must be a 10-digit phone number.');
                focusAndScrollTo(el);
                return false;
            }
        }
        return true;
    }

    // ===== Currency (WITH cents) =====
    function wireCurrency(el) {
        function formatForTyping(raw) {
            let v = (raw || '').replace(/[^0-9.]/g, '');
            const dot = v.indexOf('.');
            let int = v, dec = '';
            if (dot !== -1) {
                int = v.slice(0, dot);
                dec = v.slice(dot + 1).replace(/\./g, '').slice(0, 2);
            }
            int = int.replace(/^0+(?=\d)/, '');
            const intWithCommas = int ? int.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '0';
            return '$' + intWithCommas + (dot !== -1 ? (dec.length ? '.' + dec : '.') : '');
        }
        function formatOnBlur(raw) {
            let v = (raw || '').replace(/[^0-9.]/g, '');
            if (!v) return '';
            const dot = v.indexOf('.');
            let int = v, dec = '';
            if (dot !== -1) {
                int = v.slice(0, dot);
                dec = v.slice(dot + 1).replace(/\./g, '').slice(0, 2);
            }
            int = int.replace(/^0+(?=\d)/, '');
            const intWithCommas = (int || '0').replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            const dec2 = (dec + '00').slice(0, 2);
            return '$' + intWithCommas + '.' + dec2;
        }
        function wireOne(inputEl) {
            if (!inputEl) return;
            inputEl.setAttribute('inputmode', 'decimal');
            inputEl.setAttribute('step', '0.01');
            inputEl.classList.add('no-spinner');
            inputEl.addEventListener('input', () => {
                const wasFocused = document.activeElement === inputEl;
                inputEl.value = formatForTyping(inputEl.value);
                if (wasFocused) inputEl.selectionStart = inputEl.selectionEnd = inputEl.value.length;
                computeProgress();
            });
            inputEl.addEventListener('blur', () => { inputEl.value = formatOnBlur(inputEl.value); });
        }
        if (el instanceof HTMLElement) { wireOne(el); return; }
        const selector = [
            'input[name^="networth"][name$="[market_value]"]',
            'input[name^="networth"][name$="[liability]"]'
        ].join(',');
        document.querySelectorAll(selector).forEach(wireOne);
    }

    // ===== HARD VALIDATION per step =====
    function valNonEmpty(inputEl, msg) {
        if (!inputEl) return true;
        if (String(inputEl.value).trim() === '') {
            showError(inputEl, msg);
            focusAndScrollTo(inputEl);
            return false;
        }
        return true;
    }
    function valRadioChecked(sectionEl, name, msg) {
        const chosen = sectionEl?.querySelector(`input[name="${name}"]:checked`);
        if (!chosen) {
            const first = sectionEl?.querySelector(`input[name="${name}"]`);
            showError(first, msg);
            focusAndScrollTo(first);
            return false;
        }
        return true;
    }

    function validateStep(sectionEl) {
        if (!VALIDATION_ENABLED) return true;
        clearErrors(sectionEl);

        const step = Number(sectionEl?.getAttribute('data-step') || 0);

        // STEP 1
        if (step === 1) {
            // ===== REORDERED VALIDATION START =====
            const legal = sectionEl.querySelector('input[name="legal_name_of_business"]');
            const operating = sectionEl.querySelector('input[name="operating_name"]');
            const activity = sectionEl.querySelector('input[name="activity_area"]');
            const addr = sectionEl.querySelector('input[name="address"]');
            const phone = sectionEl.querySelector('#LeasingForm-business-phone');
            const mobile = sectionEl.querySelector('#LeasingForm-mobile-number');
            const email = sectionEl.querySelector('input[name="contact[email]"]');
            const years = sectionEl.querySelector('input[name="years_in_business"]');

            if (!valNonEmpty(legal, 'Please enter the legal business name.')) return false;
            if (!valNonEmpty(operating, 'Please enter the operating name.')) return false;
            if (!valNonEmpty(activity, 'Please enter the activity area.')) return false;
            if (!valNonEmpty(addr, 'Please enter the company address.')) return false;

            const onlyDig = s => (s || '').replace(/\D/g, '');
            const businessDigits = onlyDig(phone?.value || '');
            const mobileDigits = onlyDig(mobile?.value || '');
            if (!businessDigits && !mobileDigits) {
                showError(phone || mobile, 'Please provide at least one phone number.');
                focusAndScrollTo(phone || mobile);
                return false;
            }

            if (!valNonEmpty(email, 'Please enter your email.')) return false;
            if (!email.checkValidity()) { showError(email, 'Please enter a valid email.'); focusAndScrollTo(email); return false; }

            if (!valNonEmpty(years, 'Please enter years in business.')) return false;

            if (!valRadioChecked(sectionEl, 'commercial_bankruptcy', 'Please answer about commercial bankruptcy.')) return false;
            if (!valRadioChecked(sectionEl, 'legal_actions', 'Please answer about legal actions.')) return false;
            // ===== REORDERED VALIDATION END =====

            // NEW: require company Date of Release only if bankruptcy = Yes
            const companyDoR = document.getElementById('Company-DateOfRelease');
            if (formEl.querySelector('input[name="commercial_bankruptcy"][value="Yes"]:checked')) {
                if (!valNonEmpty(companyDoR, 'Please enter the Date of Release.')) return false;
                if (!isValidDate(companyDoR.value)) {
                    showError(companyDoR, 'Invalid Date. Format must be YYYY-MM-DD.');
                    focusAndScrollTo(companyDoR);
                    return false;
                }
            }

            if (!requireRequiredCheckboxes(sectionEl)) return false;
            if (!phonesValidSoft()) return false;
            return true;
        }

        // STEP 2
        if (step === 2) {
            const wrap = sectionEl.querySelector('.shareholder');
            if (!wrap) return true;

            const fields = Array.from(wrap.querySelectorAll('input'));
            const anyFilled = fields.some(i => String(i.value).trim().length > 0);
            if (!anyFilled) {
                if (!requireRequiredCheckboxes(sectionEl)) return false;
                return true; // shareholders optional unless started
            }

            // ===== REORDERED VALIDATION START =====
            const name = wrap.querySelector('input[name="shareholders[0][contact_name]"]');
            const addr = wrap.querySelector('input[name="shareholders[0][address]"]');
            const tel = wrap.querySelector('#Shareholders-0-Phone');
            const mob = wrap.querySelector('#Shareholders-0-Mobile');
            const how = wrap.querySelector('#Shareholders-0-HowLong');
            const hv = wrap.querySelector('#Shareholders-0-HomeValue');
            const mb = wrap.querySelector('#Shareholders-0-MortgageBalance');
            const yearInc = wrap.querySelector('#Shareholders-0-YearIncorporated');

            if (!valNonEmpty(name, 'Shareholder contact name is required.')) return false;
            if (!valNonEmpty(addr, 'Shareholder address is required.')) return false;

            const onlyDig = s => (s || '').replace(/\D/g, '');
            const telDigits = onlyDig(tel?.value || '');
            const mobDigits = onlyDig(mob?.value || '');
            if (!telDigits && !mobDigits) {
                showError(tel || mob, 'Provide at least one phone for shareholder.');
                focusAndScrollTo(tel || mob);
                return false;
            }
            if (!phonesValidSoft()) return false;

            if (!valRadioChecked(wrap, 'shareholders[0][home_status]', 'Select Home Owner or Lessee.')) return false;

            if (!valNonEmpty(how, 'Please enter How Long at current residence.')) return false;

            const selectedHomeStatus = wrap.querySelector('input[name="shareholders[0][home_status]"]:checked');
            if (selectedHomeStatus && selectedHomeStatus.value === 'Home Owner') {
                if (!valNonEmpty(hv, 'Home Value is required for home owners.')) return false;
                if (!valNonEmpty(mb, 'Mortgage Balance is required for home owners.')) return false;
            }

            if (!valRadioChecked(wrap, 'shareholders[0][commercial_bankruptcy]', 'Please pick one option.')) return false;

            const shDoR = wrap.querySelector('#Shareholders-0-DateOfRelease');
            if (wrap.querySelector('input[name="shareholders[0][commercial_bankruptcy]"][value="Yes"]:checked')) {
                if (!valNonEmpty(shDoR, 'Please enter the Date of Release.')) return false;
                if (!isValidDate(shDoR.value)) {
                    showError(shDoR, 'Invalid Date. Format must be YYYY-MM-DD.');
                    focusAndScrollTo(shDoR);
                    return false;
                }
            }

            if (!valNonEmpty(yearInc, 'Please enter the Year Incorporated.')) return false;
            // ===== REORDERED VALIDATION END =====

            if (!requireRequiredCheckboxes(sectionEl)) return false;

            return true;
        }

        // STEP 3
        if (step === 3) {
            const rows = sectionEl.querySelectorAll('.ownership-row');
            let total = 0;
            let startedCount = 0;

            for (const row of rows) {
                const name = row.querySelector('input[name$="[contact_name]"]');
                const addr = row.querySelector('input[name$="[address]"]');
                const dob = row.querySelector('input[name$="[dob]"]');
                const pct = row.querySelector('input[name$="[percent]"]');

                const started = [name, pct, addr, dob].some(i => String(i?.value || '').trim());
                if (!started) continue;

                startedCount += 1;

                if (!valNonEmpty(name, 'Contact Name is required.')) return false;
                if (!valNonEmpty(addr, 'Address is required.')) return false;
                if (!isValidDate(dob.value)) {
                    showError(dob, 'Invalid DOB. Format must be YYYY-MM-DD.');
                    focusAndScrollTo(dob);
                    return false;
                }
                if (!valNonEmpty(pct, 'Ownership % is required.')) return false;

                const n = parseInt(pct.value, 10);
                if (isNaN(n) || n < 25 || n > 100) {
                    showError(pct, 'Ownership % must be between 25 and 100.');
                    focusAndScrollTo(pct);
                    return false;
                }
                total += n;
            }

            if (startedCount === 0) {
                const firstPct = sectionEl.querySelector('.ownership-row input[name$="[percent]"]') || sectionEl.querySelector('.ownership-row input');
                showError(firstPct, 'Please enter at least one owner.');
                focusAndScrollTo(firstPct);
                return false;
            }

            if (startedCount === 1) {
                if (total !== 100) { alert('Single owner must have 100% ownership.'); return false; }
            } else {
                if (total !== 100) { alert('Ownership percentages must total exactly 100%. Please list additional owners or adjust values.'); return false; }
            }

            if (!requireRequiredCheckboxes(sectionEl)) return false;

            return true;
        }

        // STEP 4
        if (step === 4) {
            const requireFields = (names, msg) => {
                for (const n of names) {
                    const el = sectionEl.querySelector(`[name="${n}"]`);
                    if (!el || String(el.value).trim() === '') {
                        showError(el, msg);
                        focusAndScrollTo(el);
                        return false;
                    }
                }
                return true;
            };

            // ===== BUG FIX: ADDED VALIDATION FOR PROPERTY SECTION =====

            if (!requireFields([
                'networth[savings][cash_savings][market_value]',
                'networth[savings][cash_savings][liability]',
                'networth[savings][cash_savings][to_whom]'
            ], 'This field is required.')) return false;

            if (!requireFields([
                'networth[savings][stock_investments][market_value]',
                'networth[savings][stock_investments][liability]',
                'networth[savings][stock_investments][to_whom]'
            ], 'This field is required.')) return false;

            if (!requireFields([
                'networth[savings][rrsps][market_value]',
                'networth[savings][rrsps][liability]',
                'networth[savings][rrsps][to_whom]'
            ], 'This field is required.')) return false;

            const debtGroups = [
                ['networth[debts][credit_card_debt][liability]', 'networth[debts][credit_card_debt][to_whom]'],
                ['networth[debts][personal_loans][liability]', 'networth[debts][personal_loans][to_whom]'],
                ['networth[debts][other_debts][liability]', 'networth[debts][other_debts][to_whom]'],
            ];
            for (const group of debtGroups) {
                if (!requireFields(group, 'This field is required.')) return false;
            }

            if (!requireRequiredCheckboxes(sectionEl)) return false;

            return true;
        }

        return true;
    }

    // Navigation (now gated by validateStep)
    goToStep2?.addEventListener('click', (e) => {
        e.preventDefault();
        if (!validateStep(step1)) return;
        step1.classList.add('is-hidden');
        step2.classList.remove('is-hidden');
        setActiveStep(2);
        scrollAfterReveal(step2);
        computeProgress();
    });
    backToStep1?.addEventListener('click', (e) => {
        e.preventDefault();
        step2.classList.add('is-hidden');
        step1.classList.remove('is-hidden');
        setActiveStep(1);
        scrollAfterReveal(step1);
        computeProgress();
    });
    goToStep3?.addEventListener('click', (e) => {
        e.preventDefault();
        if (!validateStep(step2)) return;
        step2.classList.add('is-hidden');
        step3.classList.remove('is-hidden');
        setActiveStep(3);
        scrollAfterReveal(step3);
        computeProgress();
        enforcePercentConstraints();
    });
    backToStep2?.addEventListener('click', (e) => {
        e.preventDefault();
        step3.classList.add('is-hidden');
        step2.classList.remove('is-hidden');
        setActiveStep(2);
        scrollAfterReveal(step2);
        computeProgress();
    });
    goToStep4?.addEventListener('click', (e) => {
        e.preventDefault();
        if (!validateStep(step3)) return;
        step3.classList.add('is-hidden');
        step4.classList.remove('is-hidden');
        setActiveStep(4);
        scrollAfterReveal(step4);
        computeProgress();
        enhanceNetWorthMobile();
        wrapAllFieldsForTooltips(); // add hosts for new wrappers if any
        wireCurrency(); // wire net worth currency inputs
    });
    backToStep3?.addEventListener('click', (e) => {
        e.preventDefault();
        step4.classList.add('is-hidden');
        step3.classList.remove('is-hidden');
        setActiveStep(3);
        scrollAfterReveal(step3);
        computeProgress();
    });

    // Build contact[body]
    function buildContactBody() {
        const lines = [];
        const get = (n) => (formEl?.querySelector(`[name="${n}"]`)?.value || '').toString().trim();
        const getRadio = (name) => (formEl?.querySelector(`[name="${name}"]:checked`)?.value || '').toString().trim();

        const money = (v) => {
            if (v === '' || v == null) return '';
            const n = Number(v);
            if (Number.isNaN(n)) return String(v);
            return '$' + new Intl.NumberFormat(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(n);
        };

        lines.push('Full Credit Application');
        lines.push('================================');
        lines.push('');

        lines.push('Company Info');
        lines.push('------------');
        lines.push(`Email: ${get('contact[email]')}`);
        lines.push(`Legal Name: ${get('legal_name_of_business')}`);
        lines.push(`Operating Name: ${get('operating_name')}`);
        lines.push(`Activity Area: ${get('activity_area')}`);
        lines.push(`Address: ${get('address')}`);
        lines.push(`Business Phone: ${get('business_phone')}`);
        lines.push(`Mobile Number: ${get('mobile_number')}`);
        lines.push(`Years in Business: ${get('years_in_business')}`);
        lines.push(`Commercial Bankruptcy: ${getRadio('commercial_bankruptcy')}`);
        // Include company Date of Release if present
        const _companyDoR = document.getElementById('Company-DateOfRelease')?.value || '';
        if (_companyDoR) lines.push(`Date of Release: ${_companyDoR}`);
        lines.push(`Legal Actions: ${getRadio('legal_actions')}`);
        lines.push('');

        (function () {
            const rows = Array.from(formEl.querySelectorAll('[name^="shareholders["]'))
                .reduce((map, f) => {
                    const m = f.name.match(/^shareholders\[(\d+)\]\[([^\]]+)\]$/);
                    if (!m) return map;
                    const [, idx, key] = m;
                    if (!map[idx]) map[idx] = {};
                    map[idx][key] = (f.type === 'radio')
                        ? (formEl.querySelector(`[name="${f.name}"]:checked`)?.value || '')
                        : (f.value || '');
                    return map;
                }, {});
            const order = Object.keys(rows).sort((a, b) => +a - +b);
            if (!order.length) return;
            lines.push('Shareholders / Partners');
            lines.push('-----------------------');
            order.forEach((idx, i) => {
                const d = rows[idx] || {};
                lines.push(`• Shareholder #${i + 1}`);
                lines.push(`  Contact Name: ${d.contact_name || ''}`);
                lines.push(`  Address: ${d.address || ''}`);
                lines.push(`  Telephone: ${d.telephone || ''}`);
                lines.push(`  Mobile: ${d.mobile || ''}`);
                lines.push(`  Home Status: ${d.home_status || ''}`);
                lines.push(`  How Long: ${d.how_long || ''}`);
                lines.push(`  Home Value: ${d.home_value || ''}`);
                lines.push(`  Mortgage Balance: ${d.mortgage_balance || ''}`);
                lines.push(`  Commercial Bankruptcy: ${d.commercial_bankruptcy || ''}`);
                lines.push(`  Date of Release: ${d.date_of_release || ''}`);
                lines.push(`  Year Incorporated: ${d.year_incorporated || ''}`);
                lines.push('');
            });
        })();

        (function () {
            const rows = Array.from(formEl.querySelectorAll('[name^="ownership["]'))
                .reduce((map, f) => {
                    const m = f.name.match(/^ownership\[(\d+)\]\[([^\]]+)\]$/);
                    if (!m) return map;
                    const [, idx, key] = m;
                    if (!map[idx]) map[idx] = {};
                    map[idx][key] = f.value || '';
                    return map;
                }, {});
            const order = Object.keys(rows).sort((a, b) => +a - +b);
            if (!order.length) return;
            lines.push('Ownership Breakdown');
            lines.push('-------------------');
            order.forEach((idx, i) => {
                const d = rows[idx] || {};
                lines.push(`• Owner #${i + 1}`);
                lines.push(`  Contact Name: ${d.contact_name || ''}`);
                lines.push(`  Address: ${d.address || ''}`);
                lines.push(`  Date of Birth: ${d.dob || ''}`);
                lines.push(`  Ownership %: ${d.percent || ''}`);
                lines.push('');
            });
        })();

        (function () {
            function table(headers, rows) {
                const widths = headers.map((h, i) =>
                    Math.max(
                        String(h).length,
                        ...rows.map(r => String(r[i] ?? '').length)
                    )
                );
                const sep = '+' + widths.map(w => '-'.repeat(w + 2)).join('+') + '+';
                const hRow = '|' + headers.map((h, i) => ' ' + String(h).padEnd(widths[i]) + ' ').join('|') + '|';
                const body = rows.map(r =>
                    '|' + r.map((cell, i) => ' ' + String(cell ?? '').padEnd(widths[i]) + ' ').join('|') + '|'
                ).join('\n');
                return [sep, hRow, sep, body, sep].filter(Boolean).join('\n');
            }

            const get = (n) => (formEl?.querySelector(`[name="${n}"]`)?.value || '').trim();
            const money = (v) => {
                if (v === '' || v == null) return '';
                const n = Number(v);
                if (Number.isNaN(n)) return String(v);
                return '$' + new Intl.NumberFormat(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(n);
            };

            const propRows = [
                ['Home', money(get('networth[property][home][market_value]')) || '-', money(get('networth[property][home][liability]')) || '-', get('networth[property][home][to_whom]') || '-'],
                ['Property 1', money(get('networth[property][property_1][market_value]')) || '-', money(get('networth[property][property_1][liability]')) || '-', get('networth[property][property_1][to_whom]') || '-'],
                ['Property 2', money(get('networth[property][property_2][market_value]')) || '-', money(get('networth[property][property_2][liability]')) || '-', get('networth[property][property_2][to_whom]') || '-'],
            ].filter(row => row.slice(1).some(v => v !== '-'));

            const savRows = [
                ['Cash & Savings (Total)', money(get('networth[savings][cash_savings][market_value]')) || '-', money(get('networth[savings][cash_savings][liability]')) || '-', get('networth[savings][cash_savings][to_whom]') || '-'],
                ['Stock Investments (Total)', money(get('networth[savings][stock_investments][market_value]')) || '-', money(get('networth[savings][stock_investments][liability]')) || '-', get('networth[savings][stock_investments][to_whom]') || '-'],
                ['RRSPs', money(get('networth[savings][rrsps][market_value]')) || '-', money(get('networth[savings][rrsps][liability]')) || '-', get('networth[savings][rrsps][to_whom]') || '-'],
            ].filter(row => row.slice(1).some(v => v !== '-'));

            const debtRows = [
                ['Credit Card Debt (Total)', money(get('networth[debts][credit_card_debt][liability]')) || '-', get('networth[debts][credit_card_debt][to_whom]') || '-'],
                ['Personal Loans (Total)', money(get('networth[debts][personal_loans][liability]')) || '-', get('networth[debts][personal_loans][to_whom]') || '-'],
                ['Other Debts (Total)', money(get('networth[debts][other_debts][liability]')) || '-', get('networth[debts][other_debts][to_whom]') || '-'],
            ].filter(row => row.slice(1).some(v => v !== '-'));

            const hasAny = propRows.length || savRows.length || debtRows.length;
            if (!hasAny) return;

            lines.push('Personal Net Worth');
            lines.push('------------------');

            if (propRows.length) {
                lines.push('Property / Real Estate');
                lines.push(table(['Item', 'Market Value', 'Liability', 'To Whom'], propRows));
                lines.push('');
            }

            if (savRows.length) {
                lines.push('Cash, Savings & Investments');
                lines.push(table(['Item', 'Market Value', 'Liability', 'To Whom'], savRows));
                lines.push('');
            }

            if (debtRows.length) {
                lines.push('Debts');
                lines.push(table(['Item', 'Liability', 'To Whom'], debtRows));
                lines.push('');
            }
        })();

        return lines.join('\n');
    }

    // Submit (validate ALL steps quickly)
    formEl?.addEventListener('submit', (e) => {
        clearErrors();
        let ok = true;

        // validate each step; if one fails, show that step and block submit
        const check = (sec, n) => {
            if (ok && !validateStep(sec)) {
                e.preventDefault();
                showStep(n);
                scrollAfterReveal(sec);
                ok = false;
            }
        };
        check(step1, 1);
        check(step2, 2);
        check(step3, 3);
        check(step4, 4);

        if (!ok || !requireRequiredCheckboxes(formEl)) { e.preventDefault(); return; }
        if (!ok) return;
        if (!phonesValidSoft()) { e.preventDefault(); return; }

        const bodyEl = document.getElementById('LeasingForm-body');
        if (bodyEl) bodyEl.value = buildContactBody();
    });

    // EXTRA HARD GATE on the submit button (blocks any handler that might auto-submit)
    submitBtn?.addEventListener('click', (e) => {
        clearErrors();
        let ok = true;

        if (ok && !validateStep(step1)) { showStep(1); ok = false; }
        if (ok && !validateStep(step2)) { showStep(2); ok = false; }
        if (ok && !validateStep(step3)) { showStep(3); ok = false; }
        if (ok && !validateStep(step4)) { showStep(4); ok = false; }

        if (!ok || !requireRequiredCheckboxes(formEl)) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation?.();
            return false;
        }

        const bodyEl = document.getElementById('LeasingForm-body');
        if (bodyEl) bodyEl.value = buildContactBody();
        return true;
    });

    // Ownership dynamic rows
    const list = document.getElementById('ownership-list');
    const addBtn = document.getElementById('add-owner');

    function wirePercentInput(el) {
        if (!el) return;
        el.setAttribute('min', '25'); el.setAttribute('max', '100');
        el.setAttribute('step', '1'); el.setAttribute('inputmode', 'numeric');
        el.setAttribute('pattern', '\\d*');
        el.addEventListener('input', () => {
            const digits = el.value.replace(/[^\d]/g, '').slice(0, 3);
            el.value = digits; computeProgress();
        });
        el.addEventListener('blur', () => {
            if (el.value === '') { computeProgress(); return; }
            let n = parseInt(el.value, 10);
            if (isNaN(n)) { el.value = ''; computeProgress(); return; }
            if (n < 25) n = 25; if (n > 100) n = 100;
            el.value = String(n); computeProgress();
        });
    }
    function enforcePercentConstraints() {
        list?.querySelectorAll('input[id$="-Percent"]').forEach(wirePercentInput);
    }
    function updateRowActionsVisibility() {
        const rows = list?.querySelectorAll('.ownership-row') || [];
        rows.forEach((row, i) => {
            const actions = row.querySelector('[data-row-actions]');
            if (!actions) return;
            actions.classList.toggle('is-hidden', i === 0);
        });
    }
    function attachRemoveHandler(rowEl) {
        const btn = rowEl.querySelector('[data-remove]');
        if (!btn) return;
        btn.addEventListener('click', () => {
            rowEl.remove();
            reindexRows();
            updateRowActionsVisibility();
            computeProgress();
        });
    }
    function buildRow(index) {
        const wrap = document.createElement('div');
        wrap.className = 'ownership-row';
        wrap.dataset.index = String(index);
        wrap.innerHTML = `
      <div class="form-group">
        <label for="Ownership-${index}-ContactName">Contact Name</label>
        <input id="Ownership-${index}-ContactName" type="text" name="ownership[${index}][contact_name]">
      </div>
      <div class="form-group">
        <label for="Ownership-${index}-Address">Address</label>
        <input id="Ownership-${index}-Address" type="text" name="ownership[${index}][address]">
      </div>
      <div class="form-group">
        <label for="Ownership-${index}-DOB">Date of Birth</label>
        <input id="Ownership-${index}-DOB" type="text" class="datepicker-input" name="ownership[${index}][dob]" placeholder="YYYY-MM-DD" autocomplete="off">
      </div>
      <div class="form-group">
        <label for="Ownership-${index}-Percent">Ownership %</label>
        <input id="Ownership-${index}-Percent" type="number" name="ownership[${index}][percent]" min="25" max="100" step="1" inputmode="numeric">
      </div>
      <div class="form-group row-actions" data-row-actions>
        <div class="form-label-spacer" aria-hidden="true"></div>
        <button type="button" class="btn-remove" data-remove>
          <span class="btn-remove__icon">✕</span>
          <span class="btn-remove__label">Remove</span>
        </button>
      </div>
    `;
        return wrap;
    }
    function reindexRows() {
        const rows = list.querySelectorAll('.ownership-row');
        rows.forEach((row, i) => {
            row.dataset.index = String(i);
            const map = [
                ['ContactName', 'contact_name'],
                ['Address', 'address'],
                ['DOB', 'dob'],
                ['Percent', 'percent']
            ];
            map.forEach(([suffix, key]) => {
                const input =
                    row.querySelector(`[id^="Ownership-"][id$="-${suffix}"]`) ||
                    row.querySelector(`[name^="ownership["][name$="[${key}]"]`);
                if (!input) return;
                const newId = `Ownership-${i}-${suffix}`;
                const newName = `ownership[${i}][${key}]`;
                input.id = newId; input.name = newName;
                const lab = input.closest('.form-group')?.querySelector('label');
                if (lab) lab.setAttribute('for', newId);
            });
            wirePercentInput(row.querySelector(`#Ownership-${i}-Percent`));
        });
    }
    addBtn?.addEventListener('click', () => {
        if (!list) return;
        const next = list.querySelectorAll('.ownership-row').length;
        const row = buildRow(next);
        list.appendChild(row);
        const newDobInput = row.querySelector('.datepicker-input');
        wireUpDatepicker(newDobInput);
        wireUpDateMask(newDobInput);
        attachRemoveHandler(row);
        wirePercentInput(row.querySelector(`#Ownership-${next}-Percent`));
        updateRowActionsVisibility();
        computeProgress();
    });
    const firstRow = list?.querySelector('.ownership-row');
    if (firstRow) {
        attachRemoveHandler(firstRow);
        wirePercentInput(firstRow.querySelector('[id$="-Percent"]'));
    }
    updateRowActionsVisibility();
    if (!step3?.classList.contains('is-hidden')) enforcePercentConstraints();

    // Numeric guards for shareholder #0 + currency wiring
    (function numericGuards() {
        const howLong = document.getElementById('Shareholders-0-HowLong');
        const homeVal = document.getElementById('Shareholders-0-HomeValue');
        const mortBal = document.getElementById('Shareholders-0-MortgageBalance');
        const yearInc = document.getElementById('Shareholders-0-YearIncorporated');
        const yearsInBusiness = document.getElementById('LeasingForm-years-in-business');

        function wireWholeNumber(el, { min = 0, max = null, maxDigits = null } = {}) {
            if (!el) return;
            el.setAttribute('inputmode', 'numeric');
            el.setAttribute('pattern', '\\d*');
            el.type = 'number'; el.step = '1'; el.min = String(min);
            if (max !== null) el.max = String(max);
            el.addEventListener('input', () => {
                let v = (el.value || '').replace(/[^\d]/g, '');
                if (maxDigits) v = v.slice(0, maxDigits);
                el.value = v; computeProgress();
            });
        }
        function markNoSpinner(el) { if (el) el.classList.add('no-spinner'); }

        wireWholeNumber(yearsInBusiness, { min: 1, maxDigits: 3 });
        wireWholeNumber(howLong, { min: 0 });

        wireCurrency(homeVal);
        wireCurrency(mortBal);

        markNoSpinner(yearsInBusiness);
        markNoSpinner(howLong);
        markNoSpinner(homeVal);
        markNoSpinner(mortBal);

        if (yearInc) {
            const currentYear = new Date().getFullYear();

            // keep the same helper, just pass dynamic max
            wireWholeNumber(yearInc, { min: 1900, max: currentYear, maxDigits: 4 });

            yearInc.addEventListener('input', () => {
                // digits only, cap at 4
                yearInc.value = (yearInc.value || '').replace(/\D/g, '').slice(0, 4);
                computeProgress();
            });

            yearInc.addEventListener('blur', () => {
                if (!yearInc.value) return;
                let n = parseInt(yearInc.value, 10);
                if (isNaN(n)) { yearInc.value = ''; computeProgress(); return; }
                if (n < 1900) n = 1900;
                if (n > currentYear) n = currentYear;
                yearInc.value = String(n);
                computeProgress();
            });
        }
    })();

    // Mobile labels for Net Worth
    (function injectNWMobileStyles() {
        const css = `
        @media (max-width:600px){
          .nw-field{ position:relative; }
          .nw-field::before{
            content: attr(data-label);
            display:block;
            margin:.15rem 0 .25rem;
            font-size:.85rem;
            line-height:1.1;
            color: var(--form-text-light, #6C757D);
            font-weight:600;
          }
        }
      `;
        const s = document.createElement('style');
        s.type = 'text/css';
        s.appendChild(document.createTextNode(css));
        document.head.appendChild(s);
    })();

    function enhanceNetWorthMobile() {
        if (!document.getElementById('step-4')) return;
        const isMobile = window.matchMedia('(max-width: 600px)').matches;
        if (!isMobile) return;

        document.querySelectorAll('.nw-section').forEach(section => {
            const header = section.querySelector('.nw-grid--header');
            if (!header) return;
            const headerCells = Array.from(header.children).slice(1).map(el => el.textContent.trim());
            section.querySelectorAll('.nw-grid:not(.nw-grid--header)').forEach(row => {
                const inputs = Array.from(row.querySelectorAll('input'));
                inputs.forEach((input, i) => {
                    if (input.parentElement && input.parentElement.classList.contains('nw-field')) return;
                    const wrap = document.createElement('div');
                    wrap.className = 'nw-field';
                    wrap.setAttribute('data-label', headerCells[i] || '');
                    if (!input.getAttribute('aria-label')) input.setAttribute('aria-label', headerCells[i] || '');
                    input.replaceWith(wrap);
                    wrap.appendChild(input);
                });
            });
        });
    }

    // Run on load
    // Run on load
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            enhanceNetWorthMobile();
            wireCurrency();
            wrapAllFieldsForTooltips();
            handleHomeStatusChange();
            handleCompanyBankruptcyToggle();
            handleShareholderBankruptcyToggle();

            // Wire up both datepicker and mask
            document.querySelectorAll('.datepicker-input').forEach(wireUpDatepicker);
            document.querySelectorAll('.datepicker-input').forEach(wireUpDateMask);

            computeProgress();

            // ===== ADD THIS LINE =====
            setTimeout(robustProgressCentering, 200);
        }, { once: true });
    } else {
        enhanceNetWorthMobile();
        wireCurrency();
        wrapAllFieldsForTooltips();
        handleHomeStatusChange();
        handleCompanyBankruptcyToggle();
        handleShareholderBankruptcyToggle();

        // Wire up both datepicker and mask here too
        document.querySelectorAll('.datepicker-input').forEach(wireUpDatepicker);
        document.querySelectorAll('.datepicker-input').forEach(wireUpDateMask);

        computeProgress();

        // ===== ADD THIS LINE =====
        setTimeout(robustProgressCentering, 200);
    }
})(); // ← This is the end of your file

